module.exports = __webpack_public_path__ + "static/media/02-2-galeria-02-zegna@2x.5723c9c5.jpg";